import { ChatbotApi, ChatbotStatus, type IChatbotFullData } from 'entities/Chatbot'
import { EnrollSearchStore } from 'widgets/EnrollSearch'

export type ChatbotEnrollSearchStore = EnrollSearchStore<IChatbotFullData>

export const createChatbotEnrollSearchStore = (): ChatbotEnrollSearchStore =>
  new EnrollSearchStore<IChatbotFullData>({
    perPage: 10,
    getKey: (item) => item.id,
    fetchItems: async ({ term, offset, limit, cancelToken }) => {
      const page = Math.floor(offset / limit) + 1
      const {
        data: { data, meta },
      } = await ChatbotApi.getChatbotList(
        {
          page,
          limit,
          'filters[name]': term,
          'filters[status]': ChatbotStatus.Active,
        },
        { cancelToken }
      )
      return { items: data, total: meta.total }
    },
  })
